module.exports = __webpack_public_path__ + "static/media/germany.f2d7706f.svg";